import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { ResourceEditModalComponent } from './edit/resource-edit-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MissionService, GameService, TemplateService, ResourceService, LanguageService } from '../../_services/index';
import { Resource } from '../../classes';

@Component({
    selector: 'app-edit-resources-param',
    templateUrl: './edit-resources.component.html',
    styleUrls: ['./edit-resources.component.scss'],
    standalone: false
})

export class EditResourcesComponent {

  resources = [];
  resourcesSubscriber;

  gameId;
  game;
  templateId;
  template;

  url;
  objectsBytype;
  //typeLabelSelected = "";
  typeIdSelected = "";

  constructor(private route: ActivatedRoute,
    public resourceService: ResourceService,
    public gameService: GameService,
    public missionService: MissionService,
    public templateService: TemplateService,
    private dialogService: NbDialogService,
    public languageService: LanguageService) {
      this.route
      .params
      .subscribe(params => {
        // Récupération des valeurs de l'URL
        console.log('params:'+JSON.stringify(params));
        this.gameId = params['id'];
        this.templateId = params['templateId'];
        console.log('Load data - gameId:'+this.gameId+', templateId:'+this.templateId);
        
        if(this.resourcesSubscriber){
          this.resourcesSubscriber.unsubscribe();
        }
        if(this.gameId){
          this.gameService.getGame(this.gameId)
          .subscribe(game => {
            if(game){
              this.game = game;
            }
          });
          this.resourcesSubscriber = this.resourceService.listResources(`games/${this.gameId}/resources`)
          .subscribe(resources => {;
            if(resources){
              this.resources = this.sort(resources);
            }
          });
        }
        else if(this.templateId){
          this.templateService.getTemplate(this.templateId)
          .subscribe(template => {
            if(template){
              this.template = template;
            }
          });
          this.resourcesSubscriber = this.resourceService.listResources(`game_templates/${this.templateId}/resources`)
          .subscribe(resources => {
            if(resources){
              this.resources = this.sort(resources);
            }
          });
        }
      });
  }

  containsOrder(objects) {
    let exist = true
    for (let i = 0; i < objects.length; i++) {
      if (!objects[i]?.orderNum) {
        exist = false;
      }
    }
    return exist;
  }

  sort(objects){
    return objects.sort((x, y) => x.orderNum - y.orderNum);
  }

  changePosition(old_order, new_order, object){
    let old_index = this.resources.findIndex(obj => obj.objectTypeId == object.objectTypeId && old_order == obj.orderNum);
    let new_index = this.resources.findIndex(obj => obj.objectTypeId == object.objectTypeId && new_order == obj.orderNum);
    console.log('old_index:'+old_index);
    console.log('new_index:'+new_index);
    console.log('this.objects[new_index]:'+this.resources[new_index]);
    if(this.resources[new_index]){
      this.resources[old_index].orderNum = new_order
      this.resources[new_index].orderNum = old_order
      
      this.saveOrder(this.resources[old_index])
      this.saveOrder(this.resources[new_index])
      //this.objects = this.sort(this.objects)
    }
  }

  async saveOrder(resource){
    await this.resourceService.setResource(resource).then(value => {
    }, err => {
      console.log('err :', err)
    });
  }

  ngOnInit() {
  }

  editResource(resource){
    if(this.gameId){
      if(!resource){
        resource = new Resource(`games/${this.game.id}/resources`);
        resource.gameId = this.gameId;
        resource.orderNum = this.resources.length+1;
      }
      this.dialogService.open(ResourceEditModalComponent, { 
        context: {
          model: resource,
          game: this.game,
          languages: this.game.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    } else {
      if(!resource){
        resource = new Resource(`game_templates/${this.templateId}/resources`);
        resource.templateId = this.templateId;
      }
      this.dialogService.open(ResourceEditModalComponent, { 
        context: {
          model: resource,
          game: this.game,
          languages: this.template.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    }
  }

  deleteResource(resource){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete resource '`+resource.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete resource');
        await this.resourceService.deleteResource(resource);
      }
    });
  }
}